module.exports = __webpack_public_path__ + "img/icon_aqgl.27e67d4e.png";